// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { StorageCache } from './StorageCache';
export const Cache = new StorageCache();
